module.exports = __webpack_public_path__ + "static/media/dome.38423242.svg";